import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-condition-description m-0 caption" }

import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TravellerModifyMessage',
  setup(__props) {

  // Translations
  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(t)('travellers.modifyNotAllowedMessageBefore')) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      href: "mailto:support.uk@travelski.com",
      class: "email-link"
    }, "support.uk@travelski.com", -1)),
    _createTextVNode(" " + _toDisplayString(_unref(t)('travellers.modifyNotAllowedMessageAfter')), 1)
  ]))
}
}

})